/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var consts = require('./consts');
var extent = require('./extent');

var olsize = __ol__.size;
var oltilegrid = __ol__.tilegrid;
var TileGrid = __ol__.tilegrid.TileGrid;
var createXyzGrid = oltilegrid.createXYZ;
function resolutionsFromExtent(extent$$1) {
  var maxZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : consts.MAX_ZOOM;
  var tileSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : consts.TILE_SIZE;

  tileSize = olsize.toSize(tileSize);

  var height = extent.getExtentHeight(extent$$1);
  var width = extent.getExtentWidth(extent$$1);

  var maxResolution = Math.max(width / tileSize[0], height / tileSize[1]);

  var length = maxZoom + 1;
  var resolutions = new Array(length);

  for (var z = 0; z < length; ++z) {
    resolutions[z] = maxResolution / Math.pow(2, z);
  }

  return resolutions;
}

/**
 * @param {ol.Extent} extent Extent.
 * @param {number=} maxZoom Maximum zoom level (default is MAX_ZOOM).
 * @param {number|ol.Size=} tileSize Tile size (default uses TILE_SIZE).
 * @param {string|ol.extent.Corner} [corner] Extent corner (default is EXTENT_CORNER.TOP_LEFT).
 * @return {!ol.tilegrid.TileGrid} TileGrid instance.
 * @see https://github.com/openlayers/openlayers/blob/master/src/ol/tilegrid.js#L58
 */
function createGridForExtent(extent$$1) {
  var maxZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : consts.MAX_ZOOM;
  var tileSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : consts.TILE_SIZE;
  var corner = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : consts.EXTENT_CORNER.TOP_LEFT;

  var resolutions = resolutionsFromExtent(extent$$1, maxZoom, tileSize);

  return new TileGrid({
    extent: extent$$1,
    origin: extent.getExtentCorner(extent$$1, corner),
    resolutions: resolutions,
    tileSize: tileSize
  });
}

/**
 * @param {ol.ProjectionLike} projection Projection.
 * @param {number=} maxZoom Maximum zoom level (default is
 *     ol.DEFAULT_MAX_ZOOM).
 * @param {number|ol.Size=} tileSize Tile size (default uses ol.DEFAULT_TILE_SIZE).
 * @param {string|ol.extent.Corner=} corner Extent corner (default is
 *     ol.extent.Corner.BOTTOM_LEFT).
 * @return {!ol.tilegrid.TileGrid} TileGrid instance.
 * @see https://github.com/openlayers/openlayers/blob/master/src/ol/tilegrid.js#L135
 */
function createGridForProjection(projection) {
  var maxZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : consts.MAX_ZOOM;
  var tileSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : consts.TILE_SIZE;
  var corner = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : consts.EXTENT_CORNER.BOTTOM_LEFT;

  return createGridForExtent(extent.createExtentFromProjection(projection), maxZoom, tileSize, corner);
}

exports.createXyzGrid = createXyzGrid;
exports.resolutionsFromExtent = resolutionsFromExtent;
exports.createGridForExtent = createGridForExtent;
exports.createGridForProjection = createGridForProjection;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/tile-grid.js
// module id = 243
// module chunks = 1